<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <ButtonDefault :button-name="$t('shooting.buttons.download.download')" :loading="downloadLoading" v-on="on" />
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" @click="download(item)">
          <v-list-item-title>{{ buttonsName(item.type) }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import api from '@/script/api'
import ButtonDefault from './common/atoms/ButtonDefault.vue'

export default {
  components: {
    ButtonDefault
  },
  props: {
    shootingId: {
      type: String,
      default: ''
    },
    registration: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    downloadLoading: false,
    items: [
      { type: 'ORIGINAL_WITHOUT_PROCESSES' },
      { type: 'ORIGINAL_WITH_PROCESSES' },
      { type: 'STAMPED_WITH_PROCESSES' }
    ]
  }),
  methods: {
    buttonsName(name) {
      if (name === 'ORIGINAL_WITHOUT_PROCESSES') return this.$t('shooting.buttons.download.originalWithoutProcesses')
      if (name === 'ORIGINAL_WITH_PROCESSES') return this.$t('shooting.buttons.download.originalWithProcesses')
      if (name === 'STAMPED_WITH_PROCESSES') return this.$t('shooting.buttons.download.stampedWithProcesses')
    },
    async download(item) {
      const imageType = item.type

      this.downloadLoading = true
      const response = await api.downloadShooting(this.shootingId, this.registration, this.date, imageType)

      if (!response) {
        this.$store.commit('SET_SNACKBAR', { snack: this.$t('api.commonError'), color: 'error' })
        this.downloadLoading = false
      } else {
        this.$mam.shootingsDownload(imageType)
        this.downloadLoading = false
      }
    }
  }
}
</script>
